module.exports = __webpack_public_path__ + "img/LIVE-LOGO.33b594fe.svg";